module.exports = function (core) {
  const float = function (opts) {
    let r = core.integer(opts)
    return r / opts.fixed
  }
  return float
}



// WEBPACK FOOTER //
// ./src/private/handlers/float.js